const comments = [
  {
    headline: '这才是真正的深夜精神食粮',
    body: '每天睡前必刷一遍51每日大赛，比刷短视频还上瘾。上次那个直播翻车的大瓜，我全程围观了三天三夜，编辑部更新速度是真的猛，基本事件发生后半小时就有详细报道了。资深吃瓜群众认证！',
    name: '深夜吃瓜人',
    role: '三年老粉 · 忠实读者',
  },
  {
    headline: '爆料质量全网最高，不接受反驳',
    body: '对比了好几个吃瓜平台，51每日大赛的料最真最猛。上次那个酒店视频曝出来的时候，其他平台还在转二手消息，这里已经出深度追踪了。而且匿名投稿机制太贴心了，保护了爆料的兄弟姐妹们。',
    name: '娱乐圈纪检委',
    role: '活跃投稿人 · 资深爆料者',
  },
  {
    headline: '编辑部三观正，翻车都要翻得有态度',
    body: '最欣赏51每日大赛的一点是，他们不会为了流量无底线炒作。每篇爆料都有事实核查痕迹，三观在线。看他们写的网红翻车分析，既辛辣又客观，吃瓜吃出了一种新闻调查的感觉，respect！',
    name: '理性吃瓜选手',
    role: '媒体从业者 · 深度读者',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10 text-center">
          资深吃瓜群众评论
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {comments.map((item, idx) => (
            <div key={idx} className="bg-white rounded-2xl p-6 flex flex-col">
              <div className="flex items-center gap-0.5 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-3">{item.headline}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-5">{item.body}</p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="text-primary-600 text-sm font-bold">{item.name[0]}</span>
                </div>
                <div>
                  <p className="text-sm font-bold text-foreground-800">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}